import { LanguagesTypes } from '@hydra/types';
import { CreateSubscriptionRequest, Invoice, RecurlySubscription } from '@hydra/types/account';
import * as fetcher from '@hydra/utils/fetcher';
import { getUserInfo } from './userUtil';

export function changePassword (oldPassword: string, newPassword: string) {
  return fetcher.post('/api/account/change-password', {
    json: {
      oldPassword,
      newPassword
    }
  }).json();
}

export function destroySessions (locale: LanguagesTypes) {
  return fetcher.post(`/${locale}/user/destroySessions`, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  });
}

export function getRecurlySubscription (): Promise<RecurlySubscription | undefined> {
  return fetcher.get('/api/account/subscription').json();
}

export function getInvoices (): Promise<Array<Invoice>> {
  return fetcher.get('/api/account/invoices').json();
}

export async function completeSubscription (locale: LanguagesTypes, updatePayment?: boolean, addBilling?: boolean): Promise<void> {
  const user = await getUserInfo();

  window.location.href = `/${locale}/register/success?account_code=${user.accountCode}&isupdatepayment=${updatePayment ?? ''}&isaddbilling=${addBilling ?? ''}`;
}

export async function createRecurlySubscription (request: CreateSubscriptionRequest): Promise<void> {
  await fetcher.post('/api/account/subscribe', {
    json: request
  });
}

export function reactivateSubscription () {
  return fetcher.post('/api//user/reactivate-subscription').json();
}

export async function updateRecurlySubscription (request: CreateSubscriptionRequest): Promise<void> {
  await fetcher.post('/api/account/update-payment-method', {
    json: request
  });
}
